import React from 'react';
import { ConfigProvider } from 'antd';
import { ModuleRegistry, AllCommunityModule, ValidationModule } from 'ag-grid-community';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import 'react-loading-skeleton/dist/skeleton.css';
import { OccurrencesAditionalFieldsProvider } from 'contexts/OccurrencesAditionalFields';
import { BlockedTravelProvider } from 'contexts/BlockedTravelProvider';
import { OneSignalProvider } from 'contexts/OneSignal';
import { UserContextProvider } from 'contexts/UserContext';
import { SocketProvider } from 'contexts/SocketProvider';
import { NotificationCounterProvider } from 'contexts/NotificationCounterProvider';
import { ProgressBarProvider } from 'v3/components/ProgressBarContext';
import SnackbarStacked from 'v3/components/SnackbarStacked';
import theme from 'v3/theme';
import store from './store';
import Routes from './routes';
import { NotificationContextProvider } from './v3/components/Menu/Notifications';
import GlobalStyle from './styles';
import Snackbar from './v3/components/Snackbar';
import ErrorBoundary from './v3/components/ErrorBoundary';
import Alerts from './v3/pages/Alerts';
import { SidebarProvider } from 'v3/components/Menu/Sidebar/SidebarContext';

ModuleRegistry.registerModules([
  AllCommunityModule,
  ValidationModule,
]);

export default function App() {
  return (
    <UserContextProvider>
      <SocketProvider>
        <NotificationCounterProvider>
          <OneSignalProvider>
            <Provider store={store}>
              <ConfigProvider
                theme={{
                  token: {
                    controlItemBgActive: '#c2dffc',
                    controlItemBgHover: '#D8EBFF',
                  },
                }}
              >
                <ThemeProvider theme={theme}>
                  <div className="App h-100">
                    <GlobalStyle />
                    <ErrorBoundary>
                      <ProgressBarProvider>
                        <SnackbarStacked>
                          <Snackbar>
                            <Alerts />
                            <NotificationContextProvider>
                              <BlockedTravelProvider>
                                <OccurrencesAditionalFieldsProvider>
                                  <SidebarProvider>
                                    <Routes />
                                  </SidebarProvider>
                                </OccurrencesAditionalFieldsProvider>
                              </BlockedTravelProvider>
                            </NotificationContextProvider>
                          </Snackbar>
                        </SnackbarStacked>
                      </ProgressBarProvider>
                    </ErrorBoundary>
                  </div>
                </ThemeProvider>
              </ConfigProvider>
            </Provider>
          </OneSignalProvider>
        </NotificationCounterProvider>
      </SocketProvider>
    </UserContextProvider>
  );
}
